var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoALock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2511_274)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint0_linear_2511_274)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint1_linear_2511_274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.361 402.289L308.441 495.209V653.738L343.716 689.012V572.441H440.218V743.093H475.492V402.289H401.361ZM440.218 537.166H343.716V509.82L415.972 437.563H440.218V537.166Z",
    fill: "url(#paint2_linear_2511_274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.277 688.641L601.825 743.093H518.652V402.289H553.927V707.819H587.214L606.392 688.641H656.277Z",
    fill: "url(#paint3_linear_2511_274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.229 155H422.394C350.843 155 292.863 212.998 292.863 284.53V340.319L328.137 305.045V284.53C328.137 232.566 370.411 190.274 422.394 190.274H577.229C629.212 190.274 671.485 232.566 671.485 284.53V305.045L706.759 340.319V284.53C706.759 212.998 648.78 155 577.229 155Z",
    fill: "url(#paint4_linear_2511_274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.264 340.653C593.834 340.653 599.175 342.866 603.114 346.804L728.196 471.886C732.134 475.824 734.346 481.166 734.346 486.735V663.643C734.346 669.213 732.134 674.554 728.196 678.492L603.114 803.575C599.175 807.513 593.834 809.725 588.264 809.725H411.356C405.787 809.725 400.445 807.513 396.507 803.575L271.425 678.492C267.487 674.554 265.274 669.213 265.274 663.643V486.735C265.274 481.166 267.487 475.824 271.425 471.886L396.507 346.804C400.445 342.866 405.787 340.653 411.356 340.653H588.264ZM617.724 311.53C613.786 307.591 608.445 305.379 602.875 305.379H396.745C391.176 305.379 385.834 307.591 381.896 311.53L236.151 457.275C232.212 461.213 230 466.555 230 472.124V678.254C230 683.824 232.212 689.165 236.151 693.103L381.896 838.849C385.834 842.787 391.176 845 396.745 845H602.875C608.445 845 613.786 842.787 617.724 838.849L763.47 693.103C767.408 689.165 769.621 683.824 769.621 678.254V472.124C769.621 466.555 767.408 461.213 763.47 457.275L617.724 311.53Z",
    fill: "url(#paint5_linear_2511_274)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2511_274",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2511_274",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2511_274",
    x1: 391.967,
    y1: 402.289,
    x2: 391.967,
    y2: 743.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2511_274",
    x1: 587.465,
    y1: 402.289,
    x2: 587.465,
    y2: 743.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2511_274",
    x1: 499.811,
    y1: 155,
    x2: 499.811,
    y2: 340.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2511_274",
    x1: 499.81,
    y1: 305.379,
    x2: 499.81,
    y2: 845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4CA52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2511_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoALock);
export default __webpack_public_path__ + "static/media/Logo_ALock.296ffcc427106935c00feab1f944d677.svg";
export { ForwardRef as ReactComponent };